<template>
  <div class="view about-view">
    <HeaderBar />
    <div class="logo-wrap">
      <img class="logo-img" src="../../assets/images/logo.png" alt="logo" />
      <div class="title">友绿</div>
      <div class="text--sub">{{ `当前版本v${version}` }}</div>
    </div>
    <div class="content-wrap" v-html="content">
    </div>
  </div>
</template>
<script>
import HeaderBar from '../../components/HeaderBar';
import apiUtil from '../../utils/apiUtil';
import apiConst from '../../consts/apiConst';
import {isAndroid_Ios} from '../../utils/jsappUtil';
export default {
  name: 'about',
  components: {
    HeaderBar
  },
  data() {
    return {
      version: '1.0',
      content: ''
    }
  },
  created(){
    this.init()
  },
  methods: {
    async init(){
      const res = await apiUtil.post(apiConst.getAbout)
      if(res.success){
        this.content = res.content;
        if(isAndroid_Ios()=='android'){
          this.version =res.app_version;
        }else{
          this.version =res.ios_version;
        }
        

      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.about-view {
  -webkit-overflow-scrolling: touch;
  .logo-wrap {
    margin-top: 42px;
    display: flex;
    flex-direction: column;
    align-items center;
    margin-bottom:40px;

    .logo-img{
      width: 150px;
      height: 150px;
      margin-bottom: 27px;
    }

    .title {
      font-size: 32px;
      color: #333;
      margin-bottom: 20px;
    }
  }

  .content-wrap {
    margin-top: 40px;
    border-top: 1PX solid #F1F1F1;
    padding: 27px 36px 0;
    color: #333;
    font-size: 30px;
    line-height: 50px;
    margin: 0 15px;
  }
}
</style>
<style scoped>
.about-view .content-wrap >>> img {
	width: 100% !important;
	height: auto !important;
	display: block;
	margin: auto;
}

</style>
